import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../../layout/layout.component';
import { PagerService } from '../../../common/pagerService';
import { ToastrService } from 'ngx-toastr';
import { productGrdSearchFields } from '../../../common/viewModels/ReportConfig/productgradesModel';
import { AmplifyService } from '../../../common/amplify-service';

@Component({
    selector: 'productgradeslist',
    templateUrl: './productgradeslist.component.html',
    styleUrls: ['./productgradeslist.component.scss']
})
export class ProductGradesListComponent implements OnInit {
    productGradesSearchForm: FormGroup;
    isNoRecords: boolean = true;
    isSubmitted: boolean = false;
    searchFields: productGrdSearchFields = new productGrdSearchFields();
    pager: any = {};
    pagedItems: any[];
    id: number;
    length: number = 0;
    mainComponent: any;

    constructor(public _router: Router, private _formBuilder: FormBuilder,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute, private _pagerService: PagerService,
        private _mApp: MainAppComponent, private _toastrService: ToastrService, private _amplifyService: AmplifyService
    ) {
        this.mainComponent = _mApp;
    }

    ngOnInit() {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
        this.pager.pageSize =localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;;
        this.pager.pageIndex = 0;
        this.pager.pageSizeOptions = this._pagerService.pageSizeOptions;
        this.productGradesSearchForm = this._formBuilder.group({
            Name: ['',]
        });
        this.BindStaticSearchData();
        this.GetDataFromAmpliy();
        this.setPage(this.pager);
        this.ClearDataInAmplify();
    }

    setPage(page: any) {
        this.pager.pageSize = page.pageSize;
        this.pager.pageIndex = page.pageIndex;
        this.GetProductGradesList(this.pager);
    }

    BindStaticSearchData() {
        this.searchFields.PageNo = 0;
        this.searchFields.PageSize = this._pagerService.globalPageSize;
    }

    onSubmit() {
        this.pager.pageIndex = 0;
        this.ConstructSearchData();
        this.setPage(this.pager);
    }

    ConstructSearchData() {
        let searchDto = this.productGradesSearchForm.value;
        this.searchFields.Name = searchDto.Name;
    }

    Clear() {
        this.productGradesSearchForm.reset();
    }

    OnReset() {
        this.productGradesSearchForm.reset();
        this.pager.pageSize = this._mApp.pageSize;
        this.pager.pageIndex = 0;
        this.searchFields.Name = '';
        this.setPage(this.pager);
    }

    GetProductGradesList(page: any) {
        this.searchFields.PageNo = page.pageIndex;
        this.searchFields.PageSize = page.pageSize
        this._mApp.ShowLoader();
        this._http.post(this._appUrl.GetPrdGrdList, this.searchFields)
            .subscribe(
                res => {
                    var data = res.json();
                    this.isNoRecords = !(data.Result.length > 0);
                    this.length = data.PageResult.TotalRecords;
                    this.pagedItems = data.Result;
                    this._mApp.HideLoader();
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    DeletePrctGrd(id: any) {
        this.id = id;
    }

    DeletePrdctGrdById(id: number) {
        this.SaveDataInAmplify();
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.DeletePrdGrd + id)
            .subscribe(
                res => {
                    this._mApp.HideLoader();
                    this._toastrService.success(res.json().Result, '');
                    this.GetDataFromAmpliy();
                    this.setPage(this.pager);
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    SaveDataInAmplify() {
        this._amplifyService.SetStorage('productGradesList', this.productGradesSearchForm.value);
        this._amplifyService.SetStorage('productGradesList_PageNo', this.pager.pageIndex);
        this._amplifyService.SetStorage('productGradesList_PageSize', this.pager.pageSize);
    }


    GetDataFromAmpliy() {
        let storedData = this._amplifyService.GetStorage('productGradesList');
        if (storedData != undefined && storedData != null) {
            this.productGradesSearchForm.setValue(storedData);
            this.ConstructSearchData();
        }
        // let savedPageSize = this._amplifyService.GetStorage('productGradesList_PageSize');
        // this.pager.pageSize = savedPageSize > 0 ? savedPageSize : this._pagerService.pageSize;
        let pageIndex = this._amplifyService.GetStorage('productGradesList_PageNo');
        if (pageIndex != null && pageIndex != '' && pageIndex != undefined)
            this.pager.pageIndex = pageIndex;
        else
            this.pager.pageIndex = 0;
    }

    ClearDataInAmplify() {
        this._amplifyService.ClearStorage('productGradesList');
        this._amplifyService.ClearStorage('productGradesList_PageNo');
        this._amplifyService.ClearStorage('productGradesList_PageSize');
    }
}